import React, { useEffect, useState } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { useParams } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import MainDashboard from 'pages/dashboard/main-dashboard';
import GuestTable from './guest-table';
import { EventType } from 'models/event.model';
import { CompanyWalletType } from 'models/wallet.model';

const ViewEventDetails = () => {
  const { setHideSidebar, setBackLinkTitle, setIsBackLink, setBackLink, activeCompany } =
    useDashboardContext();
  const [eventDetails, setEventDetails] = useState<EventType>();
  const [eventWalletDetails, setEventWalletDetails] = useState<CompanyWalletType>();
  const [loading, setLoading] = useState(false);
  const [walletLoading, setWalletLoading] = useState(false);
  useEffect(() => {
    setHideSidebar(false);
    setIsBackLink(true);
    setBackLinkTitle('Return to Events');
    setBackLink(ROUTE_KEYS.EVENTS);
    return () => {
      setHideSidebar(false);
      setIsBackLink(false);
      setBackLinkTitle('');
      setBackLink('');
    };
  }, []);
  const { id } = useParams();
  const companyId = activeCompany?.id;

  const getEventDetails = async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const res = await apiService.get(`events/${id}`);

      setEventDetails(res.data.data);
    } finally {
      setLoading(false);
    }
  };

  const getEventWalletDetails = async () => {
    if (!id) return;
    setWalletLoading(true);
    try {
      const res = await apiService.get(`events/wallet/${id}`);
      setEventWalletDetails(res.data.data);
    } finally {
      setWalletLoading(false);
    }
  };
  useEffect(() => {
    getEventDetails();
    getEventWalletDetails();
  }, []);
  return (
    <div>
      <p className='font-[600] text-xl mb-[30px]'>{eventDetails?.name ?? '...'}</p>
      <div>
        <MainDashboard
          balance={eventWalletDetails?.available_balance.toString()}
          budget={eventDetails?.budget}
          loading={loading || walletLoading}
          userId={eventDetails?.user_id}
          eventId={eventDetails?.id}
          walletType='events'
          refetchData={getEventDetails}
        />
      </div>
      <GuestTable />
    </div>
  );
};

export default ViewEventDetails;
